import { render, staticRenderFns } from "./valueItem.vue?vue&type=template&id=195217e4&scoped=true&"
import script from "./valueItem.vue?vue&type=script&lang=js&"
export * from "./valueItem.vue?vue&type=script&lang=js&"
import style0 from "./valueItem.vue?vue&type=style&index=0&id=195217e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195217e4",
  null
  
)

export default component.exports